module.exports = __webpack_public_path__ + "img/oran_4kl.20240273.jpg";